module.exports = __webpack_public_path__ + "static/media/capn5.dac62735.webp";